var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBetweenAccounts = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3346 13C18.3346 16.225 15.7263 18.8333 12.5013 18.8333L13.3763 17.375M1.66797 7.99996C1.66797 4.77496 4.2763 2.16663 7.5013 2.16663L6.6263 3.62496M18.3346 4.79163V5.87496C18.3346 7.74996 17.5846 8.49996 15.7096 8.49996H14.4596C12.5846 8.49996 11.8346 7.74996 11.8346 5.87496V4.79163C11.8346 2.91663 12.5846 2.16663 14.4596 2.16663H15.7096C17.5846 2.16663 18.3346 2.91663 18.3346 4.79163ZM8.16797 15.125V16.2083C8.16797 18.0833 7.41797 18.8333 5.54297 18.8333H4.29297C2.41797 18.8333 1.66797 18.0833 1.66797 16.2083V15.125C1.66797 13.25 2.41797 12.5 4.29297 12.5H5.54297C7.41797 12.5 8.16797 13.25 8.16797 15.125Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBetweenAccounts);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/between-accounts.a61980053b63ccb1681a2dda3c8bd00e.svg";